export default __webpack_public_path__ + "static/Laura.Barton_9252Flags_social-fbc07ac6e0be6c230d6eae913e38bcde.jpg";